import { render, staticRenderFns } from "./HistoryQuestionShow.vue?vue&type=template&id=a9b5b244&scoped=true&"
import script from "./HistoryQuestionShow.vue?vue&type=script&lang=js&"
export * from "./HistoryQuestionShow.vue?vue&type=script&lang=js&"
import style0 from "./HistoryQuestionShow.vue?vue&type=style&index=0&id=a9b5b244&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b5b244",
  null
  
)

export default component.exports